<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row v-if="props.mode == 'List'">
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>
    </b-row>

    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const options = [
      { text: "ทั้งหมด", value: null },
      { text: "ใช้งาน", value: true },
      { text: "ไม่ใช้งาน", value: false },
    ];

    const searchList = [
      {
        id: "compName",
        label: "ชื่อผู้ประกอบการ",
        value: "",
        class: "",
        style: "",
        placeholder: "คำค้นหา",
        type: "text",
        options: [],
      },
      {
        id: "detail",
        label: "เนื้อหา",
        value: "",
        class: "",
        style: "",
        placeholder: "เนื้อหา",
        type: "text",
        options: [],
      },
    ];

    return {
      options,
      search: searchList,
      props,
    };
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
    },
    onSearchBtnClicked() {
      const params = {
        compName: this.search[0].value,
        detail: this.search[1].value,
      };

      //console.log('onSearchBtnClicked', params)

      this.$emit("handleSubmit", params);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
